import { render, staticRenderFns } from "./ResetAccountName.vue?vue&type=template&id=0dcb47ec&scoped=true&"
import script from "./ResetAccountName.vue?vue&type=script&lang=js&"
export * from "./ResetAccountName.vue?vue&type=script&lang=js&"
import style0 from "./ResetAccountName.vue?vue&type=style&index=0&id=0dcb47ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb47ec",
  null
  
)

export default component.exports